import { Type } from "@sinclair/typebox";
export const HealthResponseSchema = Type.Object({
    status: Type.Literal("ok"),
    service: Type.Literal("image-studio-api"),
    version: Type.String(),
}, { additionalProperties: false });
export const ReadyResponseSchema = Type.Object({
    status: Type.Union([Type.Literal("ready"), Type.Literal("not_ready")]),
    checks: Type.Object({
        database: Type.Union([Type.Literal("ok"), Type.Literal("error")]),
        storage: Type.Union([Type.Literal("ok"), Type.Literal("error")]),
    }, { additionalProperties: false }),
}, { additionalProperties: false });
export const GENERATION_QUALITIES = ["draft", "standard", "maximum"];
export const GENERATION_OUTPUT_FORMATS = ["png", "jpeg", "webp"];
export const GENERATION_USER_BRIEF_MAX_LENGTH = 15_000;
export const FREE_GENERATION_PROMPT_MAX_LENGTH = 20_000;
export const GPT_IMAGE_2_SIZE_CONSTRAINTS = {
    edgeMultiple: 16,
    maxEdge: 3_840,
    maxAspectRatio: 3,
    minPixels: 655_360,
    maxPixels: 8_294_400,
};
// Curated product choices from OpenAI's GPT Image 2 "Popular sizes" table.
// The model's full native constraints remain separate for historical requests.
export const GPT_IMAGE_2_DOCUMENTED_SIZES = [
    { width: 1024, height: 1024, label: "1:1 · 1024 × 1024" },
    { width: 1024, height: 1536, label: "2:3 · 1024 × 1536" },
    { width: 1536, height: 1024, label: "3:2 · 1536 × 1024" },
    { width: 2048, height: 2048, label: "1:1 · 2048 × 2048 · 2K" },
    { width: 2048, height: 1152, label: "16:9 · 2048 × 1152 · 2K" },
    { width: 3840, height: 2160, label: "16:9 · 3840 × 2160 · 4K" },
    { width: 2160, height: 3840, label: "9:16 · 2160 × 3840 · 4K" },
];
export function isDocumentedImageSize(width, height) {
    return GPT_IMAGE_2_DOCUMENTED_SIZES.some((size) => size.width === width && size.height === height);
}
export function isGptImage2SizeSupported(width, height) {
    if (!Number.isInteger(width) ||
        !Number.isInteger(height) ||
        width <= 0 ||
        height <= 0) {
        return false;
    }
    const longEdge = Math.max(width, height);
    const shortEdge = Math.min(width, height);
    const pixels = width * height;
    return (longEdge <= GPT_IMAGE_2_SIZE_CONSTRAINTS.maxEdge &&
        width % GPT_IMAGE_2_SIZE_CONSTRAINTS.edgeMultiple === 0 &&
        height % GPT_IMAGE_2_SIZE_CONSTRAINTS.edgeMultiple === 0 &&
        longEdge / shortEdge <= GPT_IMAGE_2_SIZE_CONSTRAINTS.maxAspectRatio &&
        pixels >= GPT_IMAGE_2_SIZE_CONSTRAINTS.minPixels &&
        pixels <= GPT_IMAGE_2_SIZE_CONSTRAINTS.maxPixels);
}
export function parseGenerationQualities(value) {
    const requested = (value ?? GENERATION_QUALITIES.join(","))
        .split(",")
        .map((quality) => quality.trim())
        .filter(Boolean);
    if (requested.length === 0 ||
        requested.some((quality) => !GENERATION_QUALITIES.includes(quality))) {
        throw new Error("INVALID_CONFIG:GENERATION_ALLOWED_QUALITIES");
    }
    return [...new Set(requested)];
}
export function parseGenerationOutputFormats(value) {
    const requested = (value ?? GENERATION_OUTPUT_FORMATS.join(","))
        .split(",")
        .map((format) => format.trim())
        .filter(Boolean);
    if (requested.length === 0 ||
        requested.some((format) => !GENERATION_OUTPUT_FORMATS.includes(format))) {
        throw new Error("INVALID_CONFIG:GENERATION_ALLOWED_OUTPUT_FORMATS");
    }
    return [...new Set(requested)];
}
//# sourceMappingURL=index.js.map